import { Database } from "types/supabase";
import { supabaseClient } from "supabase";
import { deleteImage, uploadImage } from "supabase/files";

export type UpdateOrganizerParams = {
  id: Database["public"]["Tables"]["organizers"]["Row"]["id"];
  uid: Database["public"]["Tables"]["organizers"]["Row"]["uid"];
  name: Database["public"]["Tables"]["organizers"]["Row"]["name"];
  email: Database["public"]["Tables"]["organizers"]["Row"]["email"];
  phone: Database["public"]["Tables"]["organizers"]["Row"]["phone"];
  whatsapp: Database["public"]["Tables"]["organizers"]["Row"]["whatsapp"];
  is_municipality: Database["public"]["Tables"]["organizers"]["Row"]["is_municipality"];
  website: Database["public"]["Tables"]["organizers"]["Row"]["website"];
  preferred_language: Database["public"]["Tables"]["organizers"]["Row"]["preferred_language"];
  description: Database["public"]["Tables"]["organizers"]["Row"]["description"];
  description_pt: Database["public"]["Tables"]["organizers"]["Row"]["description_pt"];
  enable_weekly: Database["public"]["Tables"]["organizers"]["Row"]["enable_weekly"];
  currPicture: Database["public"]["Tables"]["events"]["Row"]["picture"];
  newPicture?: File;
  venueIds?: number[];
};

export const updateOrganizer = async ({
  id,
  uid,
  name,
  email,
  phone,
  whatsapp,
  is_municipality,
  preferred_language,
  website,
  description,
  description_pt,
  enable_weekly,
  currPicture,
  newPicture,
  venueIds,
}: UpdateOrganizerParams) => {
  let picturePath = null;
  if (newPicture) {
    picturePath = await uploadImage(
      newPicture,
      `${Date.now()}.${newPicture.type.split("/")[1]}`,
      "organizers",
      uid!
    );
    if (currPicture) {
      deleteImage(currPicture!.split("/").slice(-2).join("/"), "organizers");
    }
  }

  const updatedOrganizer = {
    name,
    email,
    phone,
    whatsapp,
    is_municipality,
    preferred_language,
    website,
    description,
    description_pt,
    enable_weekly,
    picture: currPicture,
  };

  if (picturePath) {
    updatedOrganizer.picture = picturePath;
  }

  const { error } = await supabaseClient
    .from("organizers")
    .update(updatedOrganizer)
    .eq("id", id);

  if (error) {
    throw error;
  }

  // Update organizer venues relationship if venueIds is provided
  if (venueIds !== undefined) {
    // First, delete all existing relationships for this organizer
    const { error: deleteError } = await supabaseClient
      .from("organizers_venues")
      .delete()
      .eq("organizer_id", id);

    if (deleteError) {
      throw deleteError;
    }

    // Then insert the new relationships if there are any venues selected
    if (venueIds.length > 0) {
      const venueRelationships = venueIds.map((venueId) => ({
        organizer_id: id,
        venue_id: venueId,
      }));

      const { error: insertError } = await supabaseClient
        .from("organizers_venues")
        .insert(venueRelationships);

      if (insertError) {
        throw insertError;
      }
    }
  }

  return updatedOrganizer;
};
